import { FC } from "react";

import SinglePatientInsurance from "./singleInsurance";
import { PatientInsuranceProps } from "./types";
import { InsuranceAttributesProps } from "src/pages/addCase/types";
import { Controller } from "react-hook-form";



const AddCasePatientInsurances: FC<PatientInsuranceProps> = ({ control, getValues, setValue, watch }): JSX.Element => {
  const patientInsurances = watch("insurances_attributes");
  const drug_name = watch("prescription_attributes.drug_name");

  const removePatientInsurance = (index: number): void => {
    const insurancelisting: InsuranceAttributesProps[] | undefined = getValues("insurances_attributes");
    if (insurancelisting) {
      insurancelisting.splice(index, 1);
      if (index === 0 && insurancelisting.length > 0 && !insurancelisting[index].is_primary_insurance)
        insurancelisting[index].is_primary_insurance = true;

      setValue("insurances_attributes", insurancelisting);
    }
  };

  const addNewPatientInsurance = (): void => {
    const insurancelisting: InsuranceAttributesProps[] | undefined = getValues("insurances_attributes");
    if (insurancelisting) {
      const newInsurance = {
        insurance_name: "",
        policy: "",
        bin: "",
        group_number: "",
        insurance_number: "",
        member_id: "",
        pcn: "",
        relation_firstname: "",
        relation_lastname: "",
        relation_middlename: "",
        rx_group: "",
        insurance_priority: insurancelisting.length - 1,
        relation_to_patient: "self",
        global_insurance_id: null,
        is_primary_insurance: insurancelisting.length === 0, // only in case of first insurance this check will be true,
      } as InsuranceAttributesProps;
      insurancelisting.push(newInsurance);
      setValue("insurances_attributes", insurancelisting);
    }
  };

  return (
    <div className="card mb-3">
      <div className= {`card-header ${drug_name === 'iovera°' ? 'iovera-theme' : 'zilretta-theme'}`}>
        <h4 className="m-0">Patient Insurances</h4>
      </div>
      <div className="card-body">
        {/* Federal/State-Funded Healthcare Program */}
         {drug_name === "zilretta" && <Controller
            name="patient_attributes.is_enrolled_in_federal"
            control={control}
            defaultValue={undefined}
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <div className="row align-items-center mb-3">
                <div className="col-md-10 col-12 col-form-label">
                  <span>
                    <span className="text-danger fw-bold">*</span>{' '}
                    Is the patient enrolled in a federal- or state-funded healthcare program
                    such as Medicare, Medicare Advantage, Medicaid, VA, DoD, TRICARE, a
                    qualified health plan (QHP), or any other federal or state healthcare
                    plan or a pharmaceutical assistance program?
                  </span>
                </div>
                <div className="col-md-2 col-12">
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="federalProgramYes"
                      checked={value === true}
                      onChange={() => onChange(true)}
                    />
                    <label className="form-check-label" htmlFor="federalProgramYes">
                      Yes
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="federalProgramNo"
                      checked={value === false}
                      onChange={() => onChange(false)}
                    />
                    <label className="form-check-label" htmlFor="federalProgramNo">
                      No
                    </label>
                  </div>
                </div>
                {error && error.message ? (
                  <div dangerouslySetInnerHTML={{ __html: error.message }} className="text-danger text-small mt-1"></div>
                ) : null}
              </div>
            )}
          />}
        {patientInsurances && patientInsurances.map((_d, index) => (
          <SinglePatientInsurance
            key={index}
            index={index}
            control={control}
            watch={watch}
            getValues={getValues}
            setValue={setValue}
            removeInsurance={removePatientInsurance}
          />
        ))}
        <div className="text-end">
          <button type="button" className="btn btn-success" onClick={addNewPatientInsurance}>
            <i className="bi bi-plus-lg"></i> Add Insurance
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddCasePatientInsurances;
